import React from 'react';
import { IProps, IMainVisualNav, MainVisualNavElemTypeEnum, IMainVisualBackgroundImages, IMainVisualNewsAds, IMainVisualNewsAdsTable } from 'components/Home/MainVisual/types';
import { InsTypeNameEN as InsTypeNameEnEnum } from 'constants/enums/insTypeNameEN.enum';
import SliderNews from 'components/SliderNews';
import commonService from 'utils/commonService';

const MainVisual: React.FC<IProps> = (props) => {
  const [backgroundImageTheme, setBackgroundImageTheme] = React.useState<InsTypeNameEnEnum | null>((props.backgroundImages && props.backgroundImages[0].theme) || null);

  /**
   * @description 更換主視覺背景圖 (State)
   * @param theme 背景圖主題
   */
  const changeBackgroundImageTheme = (theme: InsTypeNameEnEnum) => {
    if (backgroundImageTheme !== theme) {
      setBackgroundImageTheme(theme);
    }
  };

  return (
    <div className="main-visual">
      <div className="main-visual__content">
        <div className="main-visual__main-section">
          <div className="main-visual__title">{props.title}</div>
          <div className="main-visual__sub-title">{props.subTitle}</div>
          {props.desc && (
            <div className="main-visual__desc">{props.desc}</div>
          )}
          {props.textBlock && (
            <div className="main-visual__text-block">{props.textBlock}</div>
          )}
          {/* Navigation (圓形 elements) */}
          {props.navs && (
            <div className="main-visual__navs">
              {props.navs.map((nav: IMainVisualNav, index: number) => (
                <div className={`main-visual__nav--${nav.elemType}`} key={index} onMouseOver={() => changeBackgroundImageTheme(nav.insType)}>
                  {/* Basic (主要區塊) */}
                  {nav.elemType === MainVisualNavElemTypeEnum.Basic && (
                    <div className="main-visual__nav-main-block">
                      <div className="main-visual__nav-title">{nav.title}</div>
                    </div>
                  )}
                  {/* Advanced (主要區塊 & 隱藏區塊) */}
                  {nav.elemType === MainVisualNavElemTypeEnum.Advanced && (
                    <>
                      <div className="main-visual__nav-main-block">
                        <div className="main-visual__nav-title">{nav.title}</div>
                        <p>{nav.desc}</p>
                      </div>
                      <div className="main-visual__nav-info-block">
                        <p>{nav.info}</p>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          )}
          <button type="button" className="main-visual__scroll-down-btn" onClick={props.onScroll}>{props.scrollDownBtnText ?? 'SCROLL'}</button>
        </div>
        {/* News Ads (消息廣告) */}
        {props.newsAds && (
          <div className="main-visual__news-ads">
            <div className="template-container">
              {/* 單個 Ads */}
              {props.newsAds.length === 1 && props.newsAds.map((newsAds: IMainVisualNewsAds, newsAdsIndex: number) => (
                <div className={`main-visual__news-ads-container--${newsAds.table ? 'multiple' : 'single'}`} key={newsAdsIndex}>
                  {/* 主要 Ads 內容 */}
                  <div className="main-visual__news-ads-main">
                    <div className="main-visual__news-ads-title">
                      <span>{newsAds.title}</span>
                    </div>
                    <div className="main-visual__news-ads-content">
                      <p>{newsAds.content}</p>
                    </div>
                  </div>
                  {/* Table 內容 */}
                  {newsAds.table && newsAds.table.length > 0 && (
                    <div className="main-visual__news-ads-table">
                      <table>
                        <tbody>
                          {newsAds.table.map((newsAdsTableRow: IMainVisualNewsAdsTable, newsAdsTableRowIndex: number) => newsAdsTableRow.title && newsAdsTableRow.content && (
                            <tr key={newsAdsTableRowIndex}>
                              <th>{newsAdsTableRow.title}</th>
                              <td>{newsAdsTableRow.content}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
              {/* 多個 Ads (使用 Slider) */}
              {props.newsAds.length > 1 && (
                <SliderNews name="main-visual-news-ads-slider" loopSetting>
                  {props.newsAds.map((newsAds: IMainVisualNewsAds, newsAdsIndex: number) => (
                    <SliderNews.Item key={newsAdsIndex}>
                      <div className={`main-visual__news-ads-container--${newsAds.table ? 'multiple' : 'single'}`}>
                        {/* 主要 Ads 內容 */}
                        <div className="main-visual__news-ads-main">
                          <div className="main-visual__news-ads-title">
                            <span>{newsAds.title}</span>
                          </div>
                          <div className="main-visual__news-ads-content">
                            <p>{newsAds.content}</p>
                          </div>
                        </div>
                        {/* Table 內容 */}
                        {newsAds.table && newsAds.table.length > 0 && (
                          <div className="main-visual__news-ads-table">
                            <table>
                              <tbody>
                                {newsAds.table.map((newsAdsTableRow: IMainVisualNewsAdsTable, newsAdsTableRowIndex: number) => newsAdsTableRow.title && newsAdsTableRow.content && (
                                  <tr key={newsAdsTableRowIndex}>
                                    <th>{newsAdsTableRow.title}</th>
                                    <td>{newsAdsTableRow.content}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </SliderNews.Item>
                  ))}
                </SliderNews>
              )}
            </div>
          </div>
        )}
      </div>
      {/* 主視覺背景圖 */}
      {props.backgroundImages && props.backgroundImages.map((backgroundImage: IMainVisualBackgroundImages, index: number) => {
        const visible = backgroundImage.theme === backgroundImageTheme ? ' main-visual__background--visible' : '';
        return (
          <React.Fragment key={index}>
            <div className={'main-visual__background--pc' + visible} style={{ backgroundImage: `url(${commonService.convertImageUrl(backgroundImage.pcLeftImgPath)}), url(${commonService.convertImageUrl(backgroundImage.pcRightImgPath)})` }} />
            <div className={'main-visual__background--mobile' + visible} style={{ backgroundImage: `url(${commonService.convertImageUrl(backgroundImage.mobileImgPath)})` }} />
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default MainVisual;
